const device = {
    vendorId: '0x1D57',
    productId: '0x001C',
    interface: '00',
};

export const Scanner = function (qztray) {
    /** @type {QzTray} */
    this.qztray = qztray;

    this.callback = null;

    this.connect = function () {
        let scanner = this;

        if (! scanner.qztray.connected) {
            console.log('No connection with QZ active.');
            return Promise.reject();
        }

        let _readLoop = function (streamEvent) {
            if (streamEvent.type === 'RECEIVE') {
                if(scanner.callback) {
                    scanner.callback(streamEvent.output);
                }
            }
        };

//        scanner.qztray.qz.usb.listInterfaces(device).then((interfaces) => {
//            console.log(interfaces);
//        });
//        scanner.qztray.qz.usb.listDevices(false).then((devices) => {
//            console.log(devices);
//        });

        return scanner.qztray.qz.usb.claimDevice(device).then(() => {
            if (scanner.callback) {
                scanner.qztray.qz.usb.setUsbCallbacks(_readLoop);
            }
        });
    };

    this.disconnect = function () {
        let scanner = this;

        return scanner.qztray.qz.usb.releaseDevice(device);
    };
};

export default Scanner;
